
            const data = {"name":"chevron-left-1","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M352 115 202 256l150 141-21 19-171-160L331 96z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    